<template>
  <v-dialog v-model="show" persistent max-width="700px">
    <v-card :class="classContents">
      <v-card-title>
        <h3>ABAP {{ $t('system.instance') }} {{ item.id }}</h3>
      </v-card-title>
      <v-form ref="form" v-model="valid">
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.alias') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.alias" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <!--BEGIN::Add Instance' Short Alias.2023.04.18.KWShin.-->
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.shortAlias') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.shortAlias" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
            <!--FINISH::Add Instance' Short Alias.2023.04.18.KWShin.-->
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.version') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.version" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.whetherCollected') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-checkbox v-model="item.collecting" dense class="mt-0 pt-0 pb-2"></v-checkbox>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.osType') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="item.osType" :items="osTypes" item-text="name" item-value="name" class="item-select w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.timeZone') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- BEGIN::Modified.by.KWShin.2024.01.03. -->
                <!-- eslint-disable-next-line prettier/prettier -->
                <!--v-select height="24" v-model="item.timeZoneId" :items="timeZones" item-text="name" item-value="id" class="item-select w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select-->
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-autocomplete height="24" v-model="item.timeZoneId" :items="timeZones" item-text="name" item-value="id" class="item-select w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-autocomplete>
                <!-- FINISH::Modified.by.KWShin.2024.01.03. -->
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.numberOfCpu') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-text-field v-model="item.numberOfCpu" append-icon="mdi-plus-box-outline"
                  prepend-inner-icon="mdi-minus-box-outline" min="1" max="100" class="w-auto" outlined dense
                  @click:append="item.numberOfCpu = parseInt(item.numberOfCpu, 10) + 1"
                  @click:prepend-inner="item.numberOfCpu = parseInt(item.numberOfCpu, 10) - 1"
                ></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.color') }}</span>
              </div>
              <div class="float-left column-contents">
                <BtnColor v-model="item.color" :show-wrapper="show" />
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mb-3">
          <v-col cols="12">
            <v-card flat class="dialog-form" :class="classContents">
              <div class="d-flex flex-column">
                <div class="my-1">
                  <div class="float-left column-name">
                    <span class="d-flex align-center">{{ this.$t('system.description') }}</span>
                  </div>
                  <div class="float-left column-contents">
                    <v-text-field v-model="item.description" class="w-auto" outlined dense></v-text-field>
                  </div>
                </div>
              </div>
            </v-card>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.host') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.jco.host" :rules="[rules.required]" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('common.language') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-select v-model="item.jco.language" :items="languages" item-text="text" item-value="value" class="item-select w-auto"
                  :placeholder="this.$t('common.noSelect')" :menu-props="{ offsetY: true }" outlined dense
                ></v-select>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.username') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.jco.username" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.password') }}</span>
              </div>
              <div class="float-left column-contents">
                <!-- eslint-disable-next-line prettier/prettier -->
                <v-text-field v-model="item.jco.password" class="w-auto" :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
                  :type="showPassword ? 'text' : 'password'" @click:append="showPassword = !showPassword" outlined dense
                ></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
        <v-row class="mx-3 mt-3">
          <v-col cols="6" class="pr-5">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.clientNumber') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.jco.clientNumber" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
          <v-col cols="6">
            <div class="my-1">
              <div class="float-left column-name">
                <span class="d-flex align-center">{{ $t('system.systemNumber') }}</span>
              </div>
              <div class="float-left column-contents">
                <v-text-field v-model="item.jco.systemNumber" class="w-auto" outlined dense></v-text-field>
              </div>
            </div>
          </v-col>
        </v-row>
      </v-form>
      <v-card-actions class="pa-4">
        <v-spacer></v-spacer>
        <v-btn small color="primary" @click="save" :disabled="disabledSave">{{ $t('common.save') }}</v-btn>
        <v-btn small color="primary" @click="cancel">{{ $t('common.cancel') }}</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import editable from './mixins/editable';
import { api } from '@/api/common/instances';
import BtnColor from './BtnColorNeo';

export default {
  mixins: [editable],
  components: {
    BtnColor,
  },
  data() {
    return {
      showPassword: false,
      timeZones: [],
      osTypes: [],
      languages: [],
    };
  },
  computed: {
    classContents() {
      return {
        'contents-background-dark': this.$vuetify.theme.isDark,
      };
    },
  },
  methods: {
    async onShow() {
      ({ data: this.timeZones } = await api.get('/timezones'));
      ({ data: this.osTypes } = await api.get('/ostypes'));
      this.languages = Object.keys(this.$i18n.messages).map(lang => ({
        value: lang,
        text: this.$i18n.messages[lang]['common.localLanguageName'],
      }));
    },
  },
};
</script>

<style scoped>
.empty {
  height: 50px;
}
</style>
<style>
.item-select .v-input__slot {
  height: 24px;
}
.v-input__append-inner {
  margin-top: 2px !important;
}
.v-input__prepend-inner {
  margin-top: 2px !important;
}
</style>
